<template>
  <div>
    <div class="d-flex justify-content-between">
      <h3 class="d-flex align-items-center">
        <feather-icon class="mr-50" size="20" icon="FastForwardIcon" />
        تتبع خطة عام {{ new Date().getFullYear() }}
      </h3>
      <div>
        <b-button
          variant="success d-flex align-items-center"
          @click="showExecutionModal"
        >
          <feather-icon size="18" icon="PlusIcon" />
          <span class="mx-25"> إضافة تنفيذ </span>
        </b-button>
      </div>
    </div>
    <execution-modal
      :loading="working"
      @confirm="onAddExecution"
      v-model="executionModal"
    />
    <!-- <execution-modal
      :loading="working"
      @confirm="updateExecution"
      v-model="executionModal"
      :intializeForm="editForm"
    /> -->
    <hr />
    <div>
      <execution-table
        @deleteClicked="deleteExecution($event)"
        :planDetails.sync="execution"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import ExecutionModal from "../../components/ExecutionModal.vue";
import ExecutionTable from "../../components/ExecutionTable.vue";
import PlanHistoryModal from "../../components/PlanHistoryModal.vue";
import { mapGetters, mapActions } from "vuex";
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  VBTooltip,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    ExecutionModal,
    ExecutionTable,
    PlanHistoryModal,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormRadio,
    BForm,
    BFormTextarea,
    BButton,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    year: String | Number,
  },
  data() {
    return {
      executionModal: false,
      editForm: {},
      editModal: false,
    };
  },
  computed: {
    ...mapGetters("NgoPlan/Execution", ["loading", "working", "execution"]),
  },
  methods: {
    onAddExecution(form) {
      this.addExecution(form);
      this.executionModal = false;
    },
    onUpdateExecution(form) {
      this.updateExecution(form);
      this.editModal = false;
    },
    ...mapActions("NgoPlan/Execution", [
      "fetchExecution",
      "addExecution",
      "deleteExecution",
      "updateExecution",
    ]),
    openEditModal(rowData) {
      this.editForm = {
        activity_id: rowData.id,
        months: rowData.information.months,
        beneficiaries_number: rowData.information.beneficiaries_number,
        funds: rowData.information.funds,
      };
      this.editModal = true;
    },
    showExecutionModal() {
      this.executionModal = true;
    },
  },
  created() {
    this.fetchExecution();
  },
};
</script>
